import { Injectable } from '@angular/core';
import { User } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class SignatureHtmlService {
  private readonly assetBase = 'https://firma.element.mx';

  /** HTML optimizado para pegar en Gmail/Outlook (tabla + URLs absolutas). */
  buildEmailHtml(user: User): string {
    const logoUrl = `${this.assetBase}/assets/images/element.png`;
    const lineUrl = `${this.assetBase}/assets/images/signature-line.png`;

    const photoCell = user.image
      ? `<td style="vertical-align:top;padding-right:20px;width:90px;">` +
        `<img src="${this.escape(user.image)}" alt="" width="90" height="90" border="0" ` +
        `style="width:90px;height:90px;border-radius:50%;object-fit:cover;display:block;">` +
        `</td>`
      : '';

    const emailBlock = user.email
      ? `<div style="height:16px;line-height:16px;">` +
        `<a href="mailto:${this.escape(user.email)}" style="color:#000;font-family:Helvetica,Arial,sans-serif;font-size:11px;text-decoration:none;">` +
        `${this.escape(user.email)}</a></div>`
      : '';

    return (
      `<table cellpadding="0" cellspacing="0" border="0" style="width:400px;font-family:Helvetica,Arial,sans-serif;">` +
      `<tr>` +
      photoCell +
      `<td style="vertical-align:top;">` +
      `<a href="https://element.com.mx/"><img src="${logoUrl}" alt="Element" width="125" height="39" border="0" style="width:125px;height:39px;display:block;"></a>` +
      `<img src="${lineUrl}" alt="" width="250" height="10" border="0" style="width:250px;height:auto;display:block;margin:10px 0;">` +
      `<table cellpadding="0" cellspacing="0" border="0"><tr>` +
      `<td style="vertical-align:top;padding-right:20px;">` +
      `<div style="color:#000;font-family:Helvetica,Arial,sans-serif;font-size:15px;font-weight:700;line-height:17px;">${this.escape(user.name)}</div>` +
      `<div style="color:#000;font-family:Helvetica,Arial,sans-serif;font-size:12px;font-weight:400;line-height:15px;">${this.escape(user.job)}</div>` +
      `</td>` +
      `<td style="vertical-align:top;">` +
      `<div style="height:16px;line-height:16px;">` +
      `<a href="tel:${this.escape(user.phone)}" style="color:#000;font-family:Helvetica,Arial,sans-serif;font-size:11px;text-decoration:none;">m. ${this.escape(user.phone)}</a>` +
      `</div>` +
      emailBlock +
      `<div style="line-height:24px;">` +
      `<a href="https://element.com.mx/" style="color:#000;font-family:Helvetica,Arial,sans-serif;font-size:11px;text-decoration:underline;">element.com.mx</a>` +
      `</div>` +
      `</td></tr></table>` +
      `</td></tr></table>`
    );
  }

  buildPlainText(user: User): string {
    const lines = [
      user.name,
      user.job,
      `m. ${user.phone}`,
      user.email || '',
      'element.com.mx'
    ].filter(Boolean);
    return lines.join('\n');
  }

  private escape(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
